import EducatorAuxData from "@/types/Educator/EducatorAuxData";
import SchoolDemographicResponseItem from "@/types/SchoolDemographic/SchoolDemographicResponseItem";
import WorkshopFileError from "./WorkshopFileError";

export default class WorkshopFileUploadResponse {
  Errors: WorkshopFileError[] = [];
  Educators: EducatorAuxData[] = [];
  SchoolDemographics: SchoolDemographicResponseItem[] = [];
}
